// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet"; // Import for managing SEO
// import {
//   FaHandHoldingHeart,
//   FaBalanceScale,
//   FaChartLine,
// } from "react-icons/fa";
// import { MdHighQuality, MdOutlineEco, MdLightbulb } from "react-icons/md";
// import WhatsAppChatWidget from "./WhatsAppChatWidget";

// const About = () => {
//   const [activeTab, setActiveTab] = useState("tab1");

//   // SEO Meta Data

//   // Function to handle the tab change
//   const openTab = (tabId) => {
//     setActiveTab(tabId);
//   };

//   // Update document title when component mounts (optional fallback)
//   useEffect(() => {
//     document.title = pageTitle;
//   }, []);
//   const pageTitle =
//     "About Us - Ardor Biomed | Natural Healing with Nata De Coco & Monolaurin";
//   const pageDescription =
//     "Ardor Biomed specializes in Nata De Coco wound dressings, alcohol-free sanitizers, burn care, and coconut cosmetics powered by Lauric Acid and monolaurin.";
//   const pageUrl = "https://ecom.vishushethra.com/about";
//   const featuredImage = "https://ecom.vishushethra.com/assets/img/logo-3.png";
//   return (
//     <>
//       <Helmet>
//         {/* Primary Meta Tags */}
//         <title>{pageTitle}</title>
//         <meta name="description" content={pageDescription} />
//         <link rel="canonical" href={pageUrl} />

//         {/* Open Graph / Facebook */}
//         <meta property="og:title" content={pageTitle} />
//         <meta property="og:description" content={pageDescription} />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content={pageUrl} />
//         <meta property="og:image" content={featuredImage} />
//         <meta property="og:image:width" content="1200" />
//         <meta property="og:image:height" content="630" />
//         <meta property="og:site_name" content="Ardor Biomed" />
//         <meta property="og:locale" content="en_US" />

//         {/* Twitter Card */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content={pageTitle} />
//         <meta name="twitter:description" content={pageDescription} />
//         <meta name="twitter:image" content={featuredImage} />
//         <meta name="twitter:site" content="@ardorbiomed" />
//         <meta name="twitter:creator" content="@ardorbiomed" />

//         {/* Schema.org JSON-LD */}
//         <script type="application/ld+json">
//           {`
//           {
//             "@context": "https://schema.org",
//             "@type": "BlogPosting",
//             "headline": "${pageTitle}",
//             "description": "${pageDescription}",
//             "url": "${pageUrl}",
//             "image": "${featuredImage}",
//             "author": {
//               "@type": "Organization",
//               "name": "Ardor Biomed"
//             },
//             "publisher": {
//               "@type": "Organization",
//               "name": "Ardor Biomed",
//               "logo": {
//                 "@type": "ImageObject",
//                 "url": "https://ecom.vishushethra.com/logo.png"
//               }
//             },
//             "datePublished": "2023-11-15",
//             "mainEntityOfPage": {
//               "@type": "WebPage",
//               "@id": "${pageUrl}"
//             }
//           }
//         `}
//         </script>
//       </Helmet>

//       <div className="banner-section">
//         <img
//           src="./assets/img/bannerbreadcrumbs.jpg"
//           alt="Banner"
//           className="img-fluid banner-img"
//         />

//         <div className="breadcrumb-container">
//           <h2>About Us</h2>
//           <nav aria-label="breadcrumb">
//             <ol className="breadcrumb mb-0">
//               <li className="breadcrumb-item">
//                 <Link to="/">Home</Link>
//               </li>

//               <li className="breadcrumb-item active" aria-current="page">
//                 About Us
//               </li>
//             </ol>
//           </nav>
//         </div>
//       </div>
//       <div className="container py-4">
//         <div className="row align-items-center">
//           {/* Left: Video Section */}
//           <div className="col-md-6 mb-4 mb-md-0">
//             <video
//               src="./assets/img/video.mp4"
//               autoPlay
//               muted
//               loop
//               className="w-100 rounded"
//             >
//               Your browser does not support the video tag.
//             </video>
//           </div>

//           {/* Right: Content Section */}
//           <div className="col-md-6">
//             <h2 className="text-center">About Us</h2>
//             <p className="text-justify">
//               We, VishuShetra Indusries started since 1997 as 25 years and
//               understand the requirement of the customers and design the Hand
//               Railings and Balcony Grills as per their requirement. Our
//               designers are experienced and in the profession for long time. We
//               do undertake private works for Steel furniture and railings for
//               balcony etc. apart from being preferred contract workers for most
//               of the government engineering works. With the skilled workforce,
//               we have patented designs for the plates which are custom made as
//               per the requirement of the clients.
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="values-section">
//         <h2>Our Values</h2>
//         <div className="values-grid">
//           <div className="value-item">
//             <FaHandHoldingHeart className="value-icon" />
//             <span>Integrity</span>
//           </div>
//           <div className="value-item">
//             <FaBalanceScale className="value-icon" />
//             <span>Equality</span>
//           </div>
//           <div className="value-item">
//             <FaChartLine className="value-icon" />
//             <span>Performance Driven</span>
//           </div>
//           <div className="value-item">
//             <MdHighQuality className="value-icon" />
//             <span>Quality First</span>
//           </div>
//           <div className="value-item">
//             <MdOutlineEco className="value-icon" />
//             <span>Sustainability</span>
//           </div>
//           <div className="value-item">
//             <MdLightbulb className="value-icon" />
//             <span>Think Outside the Box</span>
//           </div>
//         </div>
//       </div>
//       <div className="tabs-container">
//         <h1 className="text-center p-3">At Ardor Biomed</h1>
//         <header className="tab-header">
//           {/* Tab Buttons */}
//           <div className="tab-buttons-container">
//             <button
//               type="button"
//               onClick={() => openTab("tab1")}
//               className={`tab-button ${activeTab === "tab1" ? "active" : ""}`}
//             >
//               What we do
//             </button>
//             <button
//               type="button"
//               onClick={() => openTab("tab2")}
//               className={`tab-button ${activeTab === "tab2" ? "active" : ""}`}
//             >
//               Impacting 8 million views
//             </button>
//             <button
//               type="button"
//               onClick={() => openTab("tab5")}
//               className={`tab-button ${activeTab === "tab5" ? "active" : ""}`}
//             >
//               Sustainable Tech at Core of our Products
//             </button>
//             <button
//               type="button"
//               onClick={() => openTab("tab3")}
//               className={`tab-button ${activeTab === "tab3" ? "active" : ""}`}
//             >
//               Goodness of Coconut
//             </button>
//             <button
//               type="button"
//               onClick={() => openTab("tab4")}
//               className={`tab-button ${activeTab === "tab4" ? "active" : ""}`}
//             >
//               Technology
//             </button>
//           </div>
//         </header>

//         {/* Tab Content */}
//         <div className="tab-body">
//           <section
//             id="tab1"
//             className={`tab-content ${activeTab === "tab1" ? "active" : ""}`}
//           >
//             <div className="tab-contentitems">
//               <div>
//                 <img
//                   src="./assets/img/abou1.png"
//                   alt="What We Do at Ardor Biomed"
//                 />
//               </div>
//               <div>
//                 <h3>What We Do</h3>
//                 <p>
//                   The key to several of our lifestyle related challenges lies in
//                   intelligent use of Biologics. For ages, mankind has harnessed
//                   nature derived compounds for a healthy lifestyle. With the
//                   advent of modern science, the quest to relieve symptom has
//                   prevailed rather than seeking a cure. Biological derivatives
//                   had taken a backfoot largely until recent times.
//                 </p>
//                 <p>
//                   We at Ardor Biomed have made it our mandate to bring the
//                   goodness of biologics for a healthy and sustainable lifestyle.
//                   We are focused on developing innovative products in the
//                   Healthcare, Cosmeceutical and nutraceutical domains leveraging
//                   technology to make our products relevant to our customers
//                 </p>
//               </div>
//             </div>
//           </section>

//           <section
//             id="tab2"
//             className={`tab-content ${activeTab === "tab2" ? "active" : ""}`}
//           >
//             {" "}
//             <div className="tab-contentitems">
//               <div>
//                 <img
//                   src="./assets/img/about2.png"
//                   alt="Impacting 8 Million Views with Coconut Products"
//                 />
//               </div>
//               <div>
//                 <h3>Impacting 8 Million Views</h3>
//                 <p>
//                   The coconut tree is the source of livelihood for more than 8
//                   million people in the Southern Indian state of Tamil Nadu.
//                   That is as many people there are in Hong Kong!
//                 </p>
//                 <p>
//                   Coconut tree or Kalpavriksha as it is called because every
//                   part of it gives value to mankind. Unfortunately, it is
//                   estimated that on an annual basis, about 200 million liters of
//                   the water found in matured coconuts go to waste without any
//                   value addition during its process in copra yards.
//                 </p>
//                 <p>
//                   We have established a supply chain for collection of the
//                   wasted matured coconut water from the copra processing yards
//                   to produce our bio-cellulose products. This has helped the
//                   rural community primarily engaged in this industry to add
//                   value by supplying this agro-waste.
//                 </p>
//               </div>
//             </div>
//           </section>
//           <section
//             id="tab5"
//             className={`tab-content ${activeTab === "tab5" ? "active" : ""}`}
//           >
//             {" "}
//             <div className="tab-contentitems">
//               <div>
//                 <img
//                   src="./assets/img/about3.jpg"
//                   alt="Sustainable Technology at Ardor Biomed"
//                 />
//               </div>
//               <div>
//                 <h3>Sustainable Tech at Core of our Products</h3>
//                 <p>Microbes! A friend and foe to mankind.</p>
//                 <p>
//                   {" "}
//                   They are around and its inevitable to deal with them. Why not
//                   make the best out of them. We have gone a long way in
//                   isolating a friendly strain of microbe that helps us to
//                   convert our coconut water based media to bio-cellulose. Just
//                   as microbes convert milk to curd, Wheat to beer, Gherkins to
//                   tasty pickles, Our friendly microscopic critter helps us
//                   produce our bio-cellulose, which is core to our products.
//                 </p>
//                 <p>
//                   We have perfected the fermentation process by isolating our
//                   own strain of microbe to produce high yields of bio-cellulose,
//                   which is totally natural, sustainably produced and have
//                   multiple applications in Healthcare, Cosmeceutical and
//                   nutraceutical domains.
//                 </p>
//               </div>
//             </div>
//           </section>
//           <section
//             id="tab3"
//             className={`tab-content ${activeTab === "tab3" ? "active" : ""}`}
//           >
//             {" "}
//             <div className="tab-contentitems">
//               <div>
//                 <img
//                   src="./assets/img/about4.jpg"
//                   alt="Health Benefits of Coconut at Ardor Biomed"
//                 />
//               </div>
//               <div>
//                 <h3>Goodness of Coconut</h3>
//                 <p>Who would say no to coconut!</p>
//                 <p>
//                   The rich and creamy flavor of coconut milk shake, the
//                   refreshing and thirst quenching coconut water, rejuvenating
//                   feel of the coconut oil or just the tropical tipsy coconut
//                   beverage. It is relished in every way possible and for a
//                   reason.
//                 </p>
//                 <p>
//                   The wonder compound, lauric acid is a key ingredient in
//                   mother's milk and also the humble coconut. Although it
//                   constitutes just 7% of mother's milk, lauric acid makes up
//                   almost 50% of virgin coconut oil. This compound has
//                   scientifically proven to have a wide spectrum anti-microbial
//                   properties in its form as monolaurin. It is also known to have
//                   anti-inflammatory properties and there are several reports of
//                   it being used as supplement for nuro-degenerative conditions
//                   such as Alzimer's. The ketones produced during monolaurin
//                   consumption helps in witght reduction.
//                 </p>
//                 <p>
//                   Our studies have shown the skin cell regeneration properties
//                   of monolaurin. Consumption of monolaurin helps to fight away
//                   infections and maintain skin health.
//                 </p>
//               </div>
//             </div>
//           </section>

//           <section
//             id="tab4"
//             className={`tab-content ${activeTab === "tab4" ? "active" : ""}`}
//           >
//             {" "}
//             <div className="tab-contentitems">
//               <div>
//                 <img
//                   src="./assets/img/about5.jpg"
//                   alt="Biotechnology at Ardor Biomed"
//                 />
//               </div>
//               <div>
//                 <h3>Technology</h3>
//                 <p>
//                   Biologics is at the core of our products. With a deep
//                   understanding about the benefits of microbes, we employ the
//                   latest bio-technological concepts to create our unique
//                   products. We emphasize on utilizing natural ingredients in all
//                   our products as functional compounds. This is ensured by our
//                   technically strong team of experts and scientists working
//                   relentlessly to bring the best products to our customers.
//                 </p>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//       <WhatsAppChatWidget
//         phoneNumber="+919488828030"
//         companyName="Ardor Biomed"
//       />
//     </>
//   );
// };

// export default About;















































import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  FaHandHoldingHeart,
  FaBalanceScale,
  FaChartLine,
  FaEye,
  FaBullseye,
  FaFlagCheckered,
} from "react-icons/fa";
import { MdHighQuality, MdOutlineEco, MdLightbulb } from "react-icons/md";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

const About = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  // SEO Meta Data
  const pageTitle =
    "About Us - VishuShethra Industries | Premium Steel Fabrication & Hand Railings";
  const pageDescription =
    "VishuShethra Industries specializes in custom hand railings, balcony grills, steel furniture, and government contract works with 25+ years of experience in steel fabrication.";
  const pageUrl = "https://vishushethra.com/about";
  const featuredImage = "https://vishushethra.com/assets/img/logo-3.png";

  // Function to handle the tab change
  const openTab = (tabId) => {
    setActiveTab(tabId);
  };

  // Update document title when component mounts
  useEffect(() => {
    document.title = pageTitle;
  }, []);

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={featuredImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="VishuShethra Industries" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={featuredImage} />
        <meta name="twitter:site" content="@vishushethra" />
        <meta name="twitter:creator" content="@vishushethra" />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "VishuShethra Industries",
            "description": "${pageDescription}",
            "url": "${pageUrl}",
            "logo": "https://vishushethra.com/logo.png",
            "foundingDate": "1997",
            "founders": [
              {
                "@type": "Person",
                "name": "Vishu Shethra"
              }
            ],
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "India"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "Customer Service"
            }
          }
        `}
        </script>
      </Helmet>

      {/* Banner Section */}
      <div className="banner-section">
        <img
          src="./assets/img/bannerbreadcrumbs.png"
          alt="Banner"
          className="img-fluid banner-img"
        />
        <div className="breadcrumb-container">
          <h2>About Us</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                About Us
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* About Content Section */}
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left: Video Section */}
          <div className="col-md-6 mb-4 mb-md-0">
            <img
              src="./assets/img/about.png" // replace with your image path
              alt="Vishushetra Steel Products"
              className="w-100 rounded shadow"
            />
          </div>

          {/* Right: Content Section */}
          <div className="col-md-6">
            <h2 className="text-center mb-4">About VishuShethra Industries</h2>
            <p className="text-justify">
              Established in 1997, VishuShethra Industries has been a trusted
              name in steel fabrication and metal works for over 25 years. We
              specialize in designing and manufacturing custom hand railings,
              balcony grills, and steel furniture that perfectly match our
              customers' requirements.
            </p>
            <p className="text-justify">
              Our team of experienced designers and skilled craftsmen bring
              decades of expertise to every project. We undertake private
              residential works as well as serve as preferred contractors for
              government engineering projects. With our skilled workforce and
              patented designs, we create custom-made solutions that combine
              durability, safety, and aesthetic appeal.
            </p>
          </div>
        </div>

        {/* Vision & Mission Section */}
        <div className="row mt-5 pt-4">
          {/* Vision Card */}
          <div className="col-md-4 mb-4">
            <div className="card h-100 shadow border-0 text-center">
              <div className="card-body p-4">
                <div className="icon-circle mb-3 mx-auto">
                  <FaEye className="vision-icon" />
                </div>
                <h4 className="card-title mb-3">Our Vision</h4>
                <p className="card-text">
                  To become India's most trusted and innovative steel
                  fabrication company, setting industry standards in quality,
                  safety, and customer satisfaction while maintaining
                  sustainable business practices.
                </p>
              </div>
            </div>
          </div>

          {/* Mission Card */}
          <div className="col-md-4 mb-4">
            <div className="card h-100 shadow border-0 text-center">
              <div className="card-body p-4">
                <div className="icon-circle mb-3 mx-auto">
                  <FaBullseye className="mission-icon" />
                </div>
                <h4 className="card-title mb-3">Our Mission</h4>
                <p className="card-text">
                  To deliver exceptional steel fabrication solutions through
                  innovative designs, superior craftsmanship, and unwavering
                  commitment to quality. We aim to build lasting relationships
                  with our clients by understanding their needs and exceeding
                  their expectations.
                </p>
              </div>
            </div>
          </div>

          {/* Values Card */}
          <div className="col-md-4 mb-4">
            <div className="card h-100 shadow border-0 text-center">
              <div className="card-body p-4">
                <div className="icon-circle mb-3 mx-auto">
                  <FaFlagCheckered className="values-icon" />
                </div>
                <h4 className="card-title mb-3">Our Promise</h4>
                <p className="card-text">
                  We promise to deliver products that are built to last, using
                  only the finest materials and adhering to the highest safety
                  standards. Every project receives our dedicated attention from
                  concept to completion, ensuring complete customer
                  satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="values-section py-5">
        <div className="container">
          <h2 className="text-center mb-5">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <FaHandHoldingHeart className="value-icon" />
              <span>Integrity</span>
              <p className="small mt-2">Honest in all our dealings</p>
            </div>
            <div className="value-item">
              <FaBalanceScale className="value-icon" />
              <span>Excellence</span>
              <p className="small mt-2">Striving for perfection</p>
            </div>
            <div className="value-item">
              <FaChartLine className="value-icon" />
              <span>Reliability</span>
              <p className="small mt-2">Consistent quality delivery</p>
            </div>
            <div className="value-item">
              <MdHighQuality className="value-icon" />
              <span>Quality First</span>
              <p className="small mt-2">Never compromising on standards</p>
            </div>
            <div className="value-item">
              <MdOutlineEco className="value-icon" />
              <span>Sustainability</span>
              <p className="small mt-2">Eco-friendly practices</p>
            </div>
            <div className="value-item">
              <MdLightbulb className="value-icon" />
              <span>Innovation</span>
              <p className="small mt-2">Creative solutions</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <div className="tabs-container py-5">
        <div className="container">
          <h1 className="text-center mb-5">What Makes Us Different</h1>

          {/* Tab Navigation */}
          <div className="tab-header">
            <div className="tab-buttons-container">
              <button
                type="button"
                onClick={() => openTab("tab1")}
                className={`tab-button ${activeTab === "tab1" ? "active" : ""}`}
              >
                Our Expertise
              </button>
              <button
                type="button"
                onClick={() => openTab("tab2")}
                className={`tab-button ${activeTab === "tab2" ? "active" : ""}`}
              >
                Quality Assurance
              </button>
              <button
                type="button"
                onClick={() => openTab("tab3")}
                className={`tab-button ${activeTab === "tab3" ? "active" : ""}`}
              >
                Custom Designs
              </button>
              <button
                type="button"
                onClick={() => openTab("tab4")}
                className={`tab-button ${activeTab === "tab4" ? "active" : ""}`}
              >
                Our Process
              </button>
              <button
                type="button"
                onClick={() => openTab("tab5")}
                className={`tab-button ${activeTab === "tab5" ? "active" : ""}`}
              >
                Materials & Safety
              </button>
            </div>
          </div>

          {/* Tab Content */}
          <div className="tab-body mt-4">
            {/* Tab 1: Our Expertise */}
            <section
              id="tab1"
              className={`tab-content ${activeTab === "tab1" ? "active" : ""}`}
            >
              <div className="tab-contentitems">
                <div>
                  <img
                    src="./assets/img/about.png"
                    alt="Our Steel Fabrication Expertise"
                    className="img-fluid rounded"
                  />
                </div>
                <div>
                  <h3>25+ Years of Expertise</h3>
                  <p>
                    With over two decades of experience in the steel fabrication
                    industry, we have mastered the art of creating durable and
                    aesthetically pleasing metal structures. Our journey began
                    in 1997, and since then, we have successfully completed
                    thousands of projects for both private and government
                    clients.
                  </p>
                  <p>
                    Our expertise spans across various domains including
                    architectural railings, industrial safety barriers,
                    residential balcony grills, and custom steel furniture. We
                    understand the unique requirements of different projects and
                    deliver solutions that are both functional and beautiful.
                  </p>
                  <p>
                    What sets us apart is our ability to combine traditional
                    craftsmanship with modern technology, ensuring that every
                    product meets the highest standards of quality and safety.
                  </p>
                </div>
              </div>
            </section>

            {/* Tab 2: Quality Assurance */}
            <section
              id="tab2"
              className={`tab-content ${activeTab === "tab2" ? "active" : ""}`}
            >
              <div className="tab-contentitems">
                <div>
                  <img
                    src="./assets/img/about2.jpg"
                    alt="Quality Assurance Process"
                    className="img-fluid rounded"
                  />
                </div>
                <div>
                  <h3>Uncompromising Quality</h3>
                  <p>
                    Quality is at the heart of everything we do. We follow a
                    rigorous quality assurance process that begins with material
                    selection and continues through every stage of production.
                    All our raw materials are sourced from certified suppliers
                    who meet our stringent quality standards.
                  </p>
                  <p>
                    Our quality control team conducts multiple inspections
                    throughout the manufacturing process. Each product undergoes
                    thorough testing for structural integrity, finish quality,
                    and safety compliance before it leaves our facility.
                  </p>
                  <p>
                    We adhere to international quality standards and
                    continuously invest in training our workforce to maintain
                    our reputation for excellence. Our commitment to quality has
                    made us the preferred choice for government contracts and
                    prestigious private projects.
                  </p>
                </div>
              </div>
            </section>

            {/* Tab 3: Custom Designs */}
            <section
              id="tab3"
              className={`tab-content ${activeTab === "tab3" ? "active" : ""}`}
            >
              <div className="tab-contentitems">
                <div>
                  <img
                    src="./assets/img/about3.jpg"
                    alt="Custom Design Solutions"
                    className="img-fluid rounded"
                  />
                </div>
                <div>
                  <h3>Custom Design Solutions</h3>
                  <p>
                    Every client is unique, and so are their requirements. Our
                    design team works closely with clients to understand their
                    vision, preferences, and practical needs. We create
                    customized designs that perfectly blend functionality with
                    aesthetics.
                  </p>
                  <p>
                    We offer a wide range of design options from traditional to
                    contemporary styles. Our patented designs for plates and
                    structural elements can be customized to suit specific
                    architectural requirements. Whether it's a simple balcony
                    grill or a complex architectural railing system, we have the
                    expertise to deliver.
                  </p>
                  <p>
                    We use advanced CAD software for design visualization,
                    allowing clients to see how the final product will look
                    before manufacturing begins. This collaborative approach
                    ensures complete satisfaction with the end result.
                  </p>
                </div>
              </div>
            </section>

            {/* Tab 4: Our Process */}
            <section
              id="tab4"
              className={`tab-content ${activeTab === "tab4" ? "active" : ""}`}
            >
              <div className="tab-contentitems">
                <div>
                  <img
                    src="./assets/img/about4.jpg"
                    alt="Our Manufacturing Process"
                    className="img-fluid rounded"
                  />
                </div>
                <div>
                  <h3>Our Manufacturing Process</h3>
                  <p>
                    Our manufacturing process combines skilled craftsmanship
                    with modern technology. It begins with detailed consultation
                    and design, followed by precise material cutting and shaping
                    using state-of-the-art equipment.
                  </p>
                  <p>
                    We employ various techniques including welding, bending,
                    forging, and finishing to create products that are both
                    strong and beautiful. Our skilled artisans pay attention to
                    every detail, ensuring perfect joints, smooth finishes, and
                    precise measurements.
                  </p>
                  <p>
                    The final stage involves quality inspection, surface
                    treatment (painting/powder coating), and packaging for safe
                    delivery. We maintain strict timelines and keep clients
                    informed at every stage of the process.
                  </p>
                </div>
              </div>
            </section>

            {/* Tab 5: Materials & Safety */}
            <section
              id="tab5"
              className={`tab-content ${activeTab === "tab5" ? "active" : ""}`}
            >
              <div className="tab-contentitems">
                <div>
                  <img
                    src="./assets/img/about5.jpg"
                    alt="Materials and Safety Standards"
                    className="img-fluid rounded"
                  />
                </div>
                <div>
                  <h3>Premium Materials & Safety</h3>
                  <p>
                    We use only the highest quality materials in all our
                    products. Our primary materials include high-grade stainless
                    steel, structural steel, and aluminum, sourced from reputed
                    manufacturers. Each material is selected for its durability,
                    strength, and corrosion resistance.
                  </p>
                  <p>
                    Safety is our top priority. All our products are designed
                    and manufactured to meet or exceed safety standards. We
                    conduct load testing, structural analysis, and safety audits
                    to ensure that our installations provide maximum protection.
                  </p>
                  <p>
                    Our installations comply with all relevant building codes
                    and safety regulations. We provide proper anchoring systems,
                    anti-slip surfaces, and child-safe designs where required.
                    Our commitment to safety has earned us the trust of
                    residential, commercial, and institutional clients.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* WhatsApp Widget */}
      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="VishuShethra Industries"
      />
    </>
  );
};

export default About;
